// extracted by mini-css-extract-plugin
export default {"copy_modal":"Layout_copy_modal__8sCQQ","middle_section":"Layout_middle_section__X6fA5","text":"Layout_text__Y8+rM","info":"Layout_info__YAITk"};